<h2 mat-dialog-title>Pastor de hogar</h2>
<mat-dialog-content>
  <p>Asignación para <strong>{{ data.personName }}</strong>.</p>
  <div *ngIf="loading" class="loading"><mat-spinner diameter="28"></mat-spinner></div>
  <mat-form-field *ngIf="!loading" appearance="fill">
    <mat-label>Pastor de hogar</mat-label>
    <mat-select [(value)]="selectedId">
      <mat-option [value]="null">Sin asignar</mat-option>
      <mat-option *ngFor="let candidate of candidates" [value]="candidate.id">{{ candidate.fullName }} · {{ candidate.ministryName }}</mat-option>
    </mat-select>
  </mat-form-field>
  <p *ngIf="!loading && !candidates.length" class="hint">No hay portadores de ministerio activos que cubran esta comunidad.</p>
  <p *ngIf="error" class="error">{{ error }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end"><button mat-button [disabled]="saving" (click)="ref.close(false)">Cancelar</button><button mat-flat-button color="primary" [disabled]="loading || saving" (click)="save()">Guardar</button></mat-dialog-actions>
